const NIGHT_ASSIST_TEXT = 'Night Assist';
export const isNAEntry = entry => {
  return typeof entry === 'string'
    ? entry === NIGHT_ASSIST_TEXT
    : entry?.shift_type === NIGHT_ASSIST_TEXT;
};
